import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import PageSection from '../../PageSection'
import LineGraph from '../../Graphs/LineGraph'

import { formatCurrency } from '../../../../helpers/numbers'

import useStyles from '../styles'

const CPAGraph = ({ rawGraphData, currencySymbol }) => {
  const classes = useStyles()

  const cpaGraphData = useMemo(() => rawGraphData && rawGraphData.data.map(data => data.value), [rawGraphData])
  const cpaGraphLabels = useMemo(() => rawGraphData && rawGraphData.data.map(data => data.segment), [rawGraphData])

  return (
    <PageSection className={classes.sectionContainer}>
      <div className={classes.headingContainer}>
        <div className={classes.title}>CPA</div>
        <div className={classes.value}>
          {formatCurrency(rawGraphData.total, { min: 2, max: 2 }, { symbol: currencySymbol })}
        </div>
      </div>
      <LineGraph
        className={classes.graphWrapper}
        data={cpaGraphData}
        labels={cpaGraphLabels}
        currencySymbol={currencySymbol}
        format="currency"
      />
    </PageSection>
  )
}

CPAGraph.propTypes = {
  rawGraphData: PropTypes.object.isRequired,
  currencySymbol: PropTypes.string
}

export default CPAGraph
